import BuildStatusSerializer from 'eflex/serializers/build-status';

export default class LiveBuildStatusSerializer extends BuildStatusSerializer {}
